import { VIDEO_EXTENSIONS } from '../constants/fileExtensions';

export const isVideoFile = (filename: string) =>
  filename.includes('youtube.com') ||
  VIDEO_EXTENSIONS.some((extension) =>
    filename.toLowerCase().replace(/\/+$/, '').endsWith(extension)
  );
